import { AppointmentID } from "./Appointment";
import { AppointmentStatusHistoryID } from "./AppointmentStatus";
import { CarCheckID } from "./CarCheck";
import { CHECKLIST_TYPES, ChecklistID } from "./Checklist";
import { UserID } from "./User";

export type CarCheckEventID = number;

export enum CHECK_EVENT_TYPE {
  Started = 1,
  Paused = 2,
  Resumed = 3,
  Aborted = 4,
  Completed = 5,
  Deleted = 6
}

export interface CarCheckEvent {
  created_on: string;
  id: CarCheckEventID;
  type: CHECK_EVENT_TYPE; // Type of the check event
  user_id: UserID; // Identifier of the user who made this check event
  checklist_id: ChecklistID; // Claire checklist Identifier
  car_check_id: CarCheckID | null; // Claire CarCheck Identifier
  appointment_status_history_id: AppointmentStatusHistoryID | null; // Claire status history Identifier
  appointment_id: AppointmentID; // Claire appointment Identifier
  user_full_name?: string; // The complete name of the user who created the check event
  checklist_name?: string; // The name of the checklist used when to create the check event
  checklist_type?: CHECKLIST_TYPES; // The type of the checklist used for the event
}
